import store from '../store'
const common = {
  // 时间戳过滤
  formatTime(number, format) {
    if(!number){
      return 
    }
    const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
    const returnArr = []

    const date = new Date(number * 1000)
    returnArr.push(date.getFullYear())
    returnArr.push(this.formatNumber(date.getMonth() + 1))
    returnArr.push(this.formatNumber(date.getDate()))

    returnArr.push(this.formatNumber(date.getHours()))
    returnArr.push(this.formatNumber(date.getMinutes()))
    returnArr.push(this.formatNumber(date.getSeconds()))

    // eslint-disable-next-line
    for (const i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i])
    }
    return format
  },
  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : `0${n}`
  },
  fomatOrderStatus(status) {
    if (status) {
      let statusList = [{
        status: 'nopay',
        name: '待付款'
      },
      {
        status: 'nosend',
        name: '待发货'
      },
      {
        status: 'cancel',
        name: '已取消'
      },
      {
        status: 'close',
        name: '已关闭'
      },
      {
        status: 'haverecived',
        name: '待评价'
      },
      {
        status: 'norecevied',
        name: '待收货'
      },
      {
        status: 'expired',
        name: '已到期'
      },
      {
        status: 'finish',
        name: '已完成'
      },
      {
        status: '1',
        name: '退款申请中'
      },
      {
        status: '2',
        name: '退款已成功'
      },
      {
        status: '3',
        name: '退款已失败'
      },
      {
        status: '4',
        name: '订单已关闭'
      },
      {
        status: '5',
        name: '退款已成功'
      },
      {
        status: '6',
        name: '退款申请中'
      },
      {
        status: 1,
        name: '退款申请中'
      },
      {
        status: 2,
        name: '退款已成功'
      },
      {
        status: 3,
        name: '退款已失败'
      },
      {
        status: 4,
        name: '订单已关闭'
      },
      {
        status: 5,
        name: '退款已成功'
      },
      {
        status: 6,
        name: '退款申请中'
      },
      ]
      let _data = statusList.filter(item => item.status === status)

      let statusname = ''
      if (_data.length) {
        statusname = _data[0].name
      }


      return statusname
    }


  },


  fomatExperienceSendWay(val) {
    let name = ''
    switch (val) {
      case 'self':
        name = '自取';
        break;
      case 'store':
        name = '门店寄存';
        break;
      default:
        name = '自取';
    }
    return name
  },
  formatexperienceStatus(status) {
    if (status) {
      let statusList = [{
        status: 'nopay',
        name: '待付款'
      },
      {
        status: 'norecevied',
        name: '待收货'
      },
      {
        status: 'expired',
        name: '已到期'
      },
      {
        status: 'finish',
        name: '已完成'
      },
      {
        status: 'nosend',
        name: '待发货'
      },
      {
        status: 'cancel',
        name: '已取消'
      },
      {
        status: 'haverecived',
        name: '待评价'
      },
      ]
      let _data = statusList.filter(item => item.status === status)
      let name = _data[0].name

      return name
    }

  },
  fomatExperienceSampleStatus(val) {
    let name = ''
    // 待寄出（总部或自取）
    // 已寄出（总部或自取）
    // 门店收取
    // 用户收取
    // 门店已收回
    // 已收回（总部或自取）
    switch (val) {
      case 'nosend':
        name = '待寄出';
        break;
      case 'send':
        name = '已寄出';
        break;
      case 'warehouserecevied':
        name = '门店收取';
        break;
      case 'recevied':
        name = '用户收取';
        break;
      case 'warehousesendbackrecevied':
        name = '门店已收回';
        break;
      case 'warehousesend':
        name = '门店寄出';
        break;
      case 'sendbackrecevied':
        name = '已收回';
        break;
      case 'nosendback':
        name = '待寄回';
        break;
      case 'sendback':
        name = '已寄回';
        break;

      default:
        name = '待寄出';
    }
    return name
  },



  obj(url) {
    return { name: 'item', url: url, response: { data: url } }
  },
  getRoutes(menulist) {
    let list = []
    // let children = []
    let menuitem = {}
    let childrenItem = {}
    if (Array.isArray(menulist)) {
      menulist.forEach((item) => {
        menuitem = {
          path: "/",
          name: '',
          id: item.id,
          meta: { navVisible: item.navVisible, requireAuth: true, title: item.title },
          component: (resolve) => require([`@/views/Home.vue`], resolve),
          // component:() => import( `@/views/Home.vue`),

          // component:(resolve) => require([`@/views/${item.rule}.vue`], resolve),
          children: []
        }
        if (item.children && item.children.length) {
          item.children.forEach((it) => {
            childrenItem = {
              path: it.rule,
              // name:"childrenItem"+it.title,
              id: it.id,
              meta: { navVisible: it.navVisible, requireAuth: true, title: it.title },
              // component:() => import( `@/views/${it.rule}.vue`),
              component: (resolve) => require([`@/views/${it.rule}.vue`], resolve)
            }
            menuitem.children.push(childrenItem)
          })
        }
        // menuitem.children = children
        list.push(menuitem)
      })
    }
    // list.push(
    //   {
    //     path: '/404',
    //     // name: '出错了',
    //     component: () => import('../views/404.vue'),
    //     hidden: true,
    //     meta: {
    //       requireAuth: false
    //     }
    //   },
    //   {
    //     path: "*",
    //     redirect: "/404",
    //     hidden: true,
    //     meta: {
    //       requireAuth: false
    //     }
    //   },
    // )
    return list
  },
  formatSize(size) {
    let arr = []
    let msg
    if (size) {
      if (size && size.indexOf(',') != -1) {
        arr = size.split(',')
        msg = '男：' + arr[0] + '\xa0\xa0\xa0\xa0\xa0\xa0' + '女：' + arr[1]
      } else {
        msg = size
      }
      return msg
    }

  },
  saveParams(path,pars){
    console.log('saveParams',path,pars)
    store.dispatch('saveListPagePars',{path,pars});
  },
  getParams(path){
    console.log('store',store)
    if(store.state.listPagePars.has(path)) {
      this.pars=store.state.listPagePars.get(path);
     
      this.formInline = this.pars
      this.pageparm.currentPage = this.pars.start+1
      this.pageparm.pageSize = this.pars.length
      this.pageparm.start =  this.pars.start
      this.pageparm.length = this.pars.length
     
    }
  },
}

export default common